export interface WorkTypeClass {
    AccountWorkTypeId: number
    AccountId: number
    WorkTypeCode: string
    WorkType: string
    SortOrder:string
    CreatedByEmployeeId: number
    CreatedOn: Date | undefined
    IsDeleted: boolean
    IsDisabled: boolean
    ModifiedByEmployeeId: number
    ModifiedOn: Date | undefined
    isSelected:number
}

export const worktypeInitialsForApp = {
    AccountWorkTypeCode: "",
    AccountWorkType: "",
    SortOrder:"",
    IsDeleted:false,
    IsDisabled:false
}

export const worktypeInitialsForUpdate = {
    AccountWorkTypeId: "",
    AccountWorkTypeCode: "",
    AccountWorkType: "",
    SortOrder:"",
    IsDeleted:false,
    IsDisabled:false
}